export class ImageSize {
  width: number;
  height: number;
  quality: number;

  constructor(width: number, height: number, quality = 60) {
    this.width = width;
    this.height = height;
    this.quality = quality;
  }

  /**
   * Returns a url for a resized image, matching provided width and height, possibly cropped.
   * @param {string} url: Image's base url
   * @return {string}: Url for resized image
   */
  getResizedUrl(url: string): string {
    return url + `${this.width}x${this.height}/${this.quality}/`;
  }

  /**
   * Returns a URL for a scaled-down version of the image. The returned image has the same aspect ratio as the source
   * image, but it is scaled down to fit within the width and height provided.
   * @param {string} url: Image's base url
   * @return {string}: Url for scaled image
   */
  getScaledToFitUrl(url: string): string {
    return this.getResizedUrl(url) + `?keep_aspect_ratio=true`;
  }
}

export class ImageSizeGroup {
  imageSizes: ImageSize[];

  constructor(imageSizes: ImageSize[]) {
    this.imageSizes = imageSizes;
  }

  getImageSrcset(url: string): string {
    const srcsetParts: string[] = [];
    this.imageSizes.forEach((imageSize) => {
      const resizedUrl = imageSize.getResizedUrl(url);
      srcsetParts.push(`${resizedUrl} ${imageSize.width}w`);
    });

    return srcsetParts.join(`, `);
  }
}
